<template>
  <div class="custom flex justify-around items-center p-0 rounded h-10 hover:bg-red-500" 
    :class="[!show() && 'bg-red-700 hover:bg-red-700', showSame && 'hidden']"
    disabled
    @mouseover="hovering"
    @mouseleave="unhovering">
    <input 
      type="text" 
      class=" w-full bg-gray-400 text-sm m-1 rounded px-1" 
      v-model="manualEdit" 
      disabled></input>
    <button :class="{'pointer-events-none': !(ids === itemId)}" class="focus:outline-none m-1" v-if="show()" @click="editTheWord">
      <i class="fas fa-edit text-xl text-blue-300 hover:text-blue-500"></i>
    </button>
    <button :class="{'pointer-events-none': !(ids === itemId)}" class="focus:outline-none m-1" v-else @click="submitEditingWord">
      <i class="fas fa-check-square text-xl text-green-300 hover:text-green-500"></i>
    </button>
    <button :class="{'pointer-events-none': !(ids === itemId)}" @click="deleteWord(bolderId)" class="border m-1 border-white flex-shrink-0 w-5 h-5 rounded-full bg-red-500 focus:outline-none hover:bg-red-700 flex items-center justify-center">
      <i class="fas fa-minus text-sm text-white"></i>
    </button>
  </div>
</template>

<script>
import { getTheWordCoordinate } from '@/helpers';

export default {
  props: ['index', 'value', 'deleteWord', 'startEditingWord', 'ids', 'itemId', 'globalIndex', 'finishEditingWord', 'bolderId', 'checkerOne', 'checkerTwo'],
  data() { 
    return {
      editWord: false,
      manualEdit: '',
    }
  },
  computed: {
    showSame() {
      if (this.checkerOne) {
        
        return this.checkerOne.toString() === this.checkerTwo.toString()
      } else {
        return false;
      }
    }
  },
  created() {
    this.manualEdit = this.value.join(' ');
    //console.log(this.checkerOne + ' --- ' +this.checkerTwo)
  },
  methods: {
    show() {
      if (this.ids === this.itemId) {
        return !(this.index === this.globalIndex)
      } else {
        return true;
      }
    },
    editTheWord() {
      this.editWord = true;
      this.startEditingWord(this.index, 'word');
    },
    submitEditingWord() {
      this.editWord = false;
      this.finishEditingWord();
    },
    hovering() {
      if (document.getElementById(`boldit${this.bolderId}`))
        document.getElementById(`boldit${this.bolderId}`).style.background = '#f50006';
    },
    unhovering() {
      if (document.getElementById(`boldit${this.bolderId}`))
        document.getElementById(`boldit${this.bolderId}`).style.background = '#81E6D9';
    }
  },
  watch: {
    value: {
      immediate: true,
      handler() {
        this.manualEdit = this.value.join(' ');
      },
      deep: true
    },
  }
}
</script>

<style>
  .customs {
    transition: all 400ms cubic-bezier(0.165, 0.84, 0.44, 1);
    transform: scale(1.1);
    z-index: 100;
    position: absolute;
    transform-origin: center;
  }
</style>